import { GET_COMPANIES_REQUEST, GET_COMPANIES_SUCCESS, GET_COMPANIES_FAILURE } from '../actions/companies';

const initialState = {
    companies: [],
    fetching: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_COMPANIES_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_COMPANIES_SUCCESS: {
            return {
                ...state,
                fetching: false,
                companies: action.payload.companies
            };
        }
        case GET_COMPANIES_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        default:
            return state;
    }
};
